import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ContactInfo } from './ContactInfo';
import { LanguageSwitcher } from '../LanguageSwitcher/LanguageSwitcher';
import './index.css';

const NAV_LINKS = [
  { path: '/', labelKey: 'header.home' },
  { path: '/about', labelKey: 'header.about' },
  { path: '/pricing', labelKey: 'header.pricing' },
  { path: '/contacts', labelKey: 'header.contacts' },
];

interface Props {
  isMobileMenuOpen: boolean;
  setIsMobileMenuOpen: (open: boolean) => void;
}

export const Header = ({ isMobileMenuOpen, setIsMobileMenuOpen }: Props) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const isActive = (path: string) =>
    path === '/' ? pathname === '/' : pathname.startsWith(path);

  return (
    <header className="header">
      <div className="header-container">
        {/* Desktop nav */}
        <nav className="navbar" aria-label="Main navigation">
          {NAV_LINKS.map(({ path, labelKey }) => (
            <Link
              key={path}
              to={path}
              className={`nav-link ${isActive(path) ? 'nav-link--active' : ''}`}
            >
              {t(labelKey)}
            </Link>
          ))}
          <a href="tel:+37126409932" className="nav-link nav-link--phone">
            +371 26 409 932
          </a>
          <LanguageSwitcher />
        </nav>

        {/* Logo */}
        <div className="logo">
          <Link to="/">
            <img src="./logo/logo_cropped.png" alt="Riga Dentique" className="logo-img" />
          </Link>
        </div>
      </div>

      {/* Mobile drawer */}
      <nav
        className={`mobile-nav-drawer ${isMobileMenuOpen ? 'open' : ''}`}
        aria-label="Mobile navigation"
        aria-hidden={!isMobileMenuOpen}
      >
        <div className="mobile-nav-top">
          <div className="mobile-nav-header">
            <LanguageSwitcher />
            <button
              className="close-button"
              onClick={() => setIsMobileMenuOpen(false)}
              aria-label="Close menu"
            >
              ✕
            </button>
          </div>

          {NAV_LINKS.map(({ path, labelKey }) => (
            <Link
              key={path}
              to={path}
              className={`nav-link ${isActive(path) ? 'nav-link--active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {t(labelKey)}
            </Link>
          ))}

          <a
            href="tel:+37126409932"
            className="nav-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            +371 26 409 932
          </a>
        </div>

        <div className="mobile-nav-bottom">
          <ContactInfo isMobile />
        </div>
      </nav>
    </header>
  );
};
